import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import TimestampTool from '../components/tools/TimestampTool';
import AddressConvert from '../components/tools/AddressConvert';
import UnitConvert from '../components/tools/UnitConvert';
import StringHexConvert from '../components/tools/StringHexConvert';
import Base64Tool from '../components/tools/Base64Tool';
import AESTool from '../components/tools/AESTool';
import KeccakTool from '../components/tools/KeccakTool';
import ExternalTools from '../components/tools/ExternalTools';
import RpcSpeedTest from '../components/tools/RpcSpeedTest';
import BinanceWalletChecker from '../components/tools/BinanceWalletChecker';
import FundFlowVisualizer from '../components/tools/FundFlowVisualizer';
import FundFlowTracker from '../components/tools/FundFlowTracker';
import BatchFundFlowTracker from '../components/tools/BatchFundFlowTracker';
import AnnouncementsPage from '../components/cex/AnnouncementsPage';
import TransferFeeBoard from '../components/cex/TransferFeeBoard';
import NotFound from '../components/NotFound';
import BatchWallet from '../components/chain/BatchWallet';
import BatchTransfer from '../components/chain/BatchTransfer';
import BatchApproval from '../components/chain/BatchApproval';
import BatchCollectEVM from '../components/chain/BatchCollectEVM';
import MultiTransfer from '../components/chain/MultiTransfer';
import EvmBalanceChecker from '../components/query/EvmBalanceChecker';
import AllowanceChecker from '../components/query/AllowanceChecker';
import NftChecker from '../components/query/NftChecker';
import BatchMint from '../components/chain/BatchMint';
import AirdropWhitelist from '../components/query/AirdropWhitelist';
import BinanceAlpha from '../components/query/BinanceAlpha';
import EthGasTracker from '../components/gas/EthGasTracker';
import WalletManager from '../components/query/WalletManager';
import WalletBtc from '../components/query/WalletBtc';
import Web3AuthPage from '../components/monitor/Web3AuthPage';
import ChannelListPage from '../components/monitor/ChannelListPage';

const AppRoutes: React.FC = () => (
  <Routes>
    {/* 根路径重定向 */}
    <Route path="/" element={<Navigate to="/chain/batch-mint" replace />} />
    {/* 实用工具 */}
    <Route path="/tools" element={<Navigate to="/tools/rpc" replace />} />
    <Route path="/tools/rpc" element={<RpcSpeedTest />} />
    <Route path="/tools/timestamp" element={<TimestampTool />} />
    <Route path="/tools/address-convert" element={<AddressConvert />} />
    <Route path="/tools/unit-convert" element={<UnitConvert />} />
    <Route path="/tools/str-hex-convert" element={<StringHexConvert />} />
    <Route path="/tools/base64" element={<Base64Tool />} />
    <Route path="/tools/aes" element={<AESTool />} />
    <Route path="/tools/keccak" element={<KeccakTool />} />
    <Route path="/tools/binance-wallet-checker" element={<BinanceWalletChecker />} />
    <Route path="/tools/fund-flow" element={<FundFlowVisualizer />} />
    <Route path="/tools/fund-flow-tracker" element={<FundFlowTracker />} />
    <Route path="/tools/batch-fund-flow-tracker" element={<BatchFundFlowTracker />} />
    <Route path="/tools/external-tools" element={<ExternalTools />} />
    {/* 批量查询 */}
    <Route path="/query" element={<Navigate to="/query/wallet-evm" replace />} />
    <Route path="/query/wallet-evm" element={<WalletManager />} />
    <Route path="/query/wallet-btc" element={<WalletBtc />} />
    <Route path="/query/batch-balance-evm" element={<EvmBalanceChecker />} />
    <Route path="/query/batch-balance-btc" element={<div>BTC余额</div>} />
    <Route path="/query/batch-balance-sol" element={<div>SOL余额</div>} />
    <Route path="/query/batch-balance-sui" element={<div>SUI余额</div>} />
    <Route path="/query/batch-balance-ton" element={<div>TON余额</div>} />
    <Route path="/query/batch-approve-query" element={<AllowanceChecker />} />
    <Route path="/query/batch-nft-query" element={<NftChecker />} />
    <Route path="/query/airdrop-whitelist" element={<AirdropWhitelist />} />
    <Route path="/query/airdrop-whitelist/:projectId" element={<AirdropWhitelist />} />
    <Route path="/query/binance-alpha" element={<BinanceAlpha />} />
    {/* 链上交互 */}
    <Route path="/chain" element={<Navigate to="/chain/batch-mint" replace />} />
    <Route path="/chain/batch-wallet" element={<BatchWallet />} />
    <Route path="/chain/batch-transfer-evm" element={<BatchTransfer />} />
    <Route path="/chain/batch-transfer-sol" element={<div>Sol转账</div>} />
    <Route path="/chain/batch-transfer-sui" element={<div>Sui转账</div>} />
    <Route path="/chain/batch-transfer-ton" element={<div>Ton转账</div>} />
    <Route path="/chain/batch-collect-evm" element={<BatchCollectEVM />} />
    <Route path="/chain/batch-collect-sol" element={<div>Sol归集</div>} />
    <Route path="/chain/batch-collect-sui" element={<div>Sui归集</div>} />
    <Route path="/chain/batch-collect-ton" element={<div>Ton归集</div>} />
    <Route path="/chain/batch-mint" element={<BatchMint />} />
    <Route path="/chain/batch-approve" element={<BatchApproval />} />
    <Route path="/chain/multi-transfer" element={<MultiTransfer />} />
    <Route path="/chain/exchange-withdraw" element={<div>交易所提币</div>} />
    <Route path="/chain/utxo-split" element={<div>UTXO拆分</div>} />
    <Route path="/chain/utxo-merge" element={<div>UTXO合并</div>} />
    <Route path="/chain/nft-freemint" element={<div>Freemint</div>} />
    <Route path="/chain/nft-batch-list" element={<div>批量挂单</div>} />
    <Route path="/chain/nft-collect" element={<div>NFT归集</div>} />
    <Route path="/chain/brc20" element={<div>BRC20</div>} />
    <Route path="/chain/runens" element={<div>Runes</div>} />
    {/* 监控 */}
    <Route path="/monitor" element={<Navigate to="/monitor/channels" replace />} />
    <Route path="/monitor/channels" element={<ChannelListPage />} />
    <Route path="/monitor/auth" element={<Web3AuthPage />} />
    <Route path="/monitor/wallet-evm" element={<div>EVM钱包监控</div>} />
    <Route path="/monitor/wallet-sol" element={<div>SOL钱包监控</div>} />
    <Route path="/monitor/wallet-btc" element={<div>BTC钱包监控</div>} />
    <Route path="/monitor/wallet-multi" element={<div>多钱包买卖监控</div>} />
    <Route path="/monitor/runes-price" element={<div>符文价格监控</div>} />
    <Route path="/monitor/runes-mint" element={<div>热门符文铸造监控</div>} />
    <Route path="/monitor/inscription-mint" element={<div>热门铭文铭刻监控</div>} />
    <Route path="/monitor/gas-burn" element={<div>GAS燃烧异常监控</div>} />
    {/* 交易所 */}
    <Route path="/cex" element={<Navigate to="/cex/announcement" replace />} />
    <Route path="/cex/announcement" element={<AnnouncementsPage />} />
    <Route path="/cex/funding-fee" element={<div>资金费</div>} />
    <Route path="/cex/transfer-fee" element={<TransferFeeBoard />} />
    {/* 实时Gas */}
    <Route path="/gas" element={<Navigate to="/gas/eth" replace />} />
    <Route path="/gas/eth" element={<EthGasTracker />} />
    {/* 404页面 */}
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AppRoutes; 